/* @flow */

import * as React from 'react';

import {Button} from '../../../button';
import {ButtonMover} from '../../../button-mover';
import {Card} from '../../../card';
import {colors} from '../../../colors';
import {AiSparkleNewIcon} from '../../../icon';
import {StackLegacy} from '../../../layout';
import {Popover} from '../../../popover';

import './summary-content.module.css';

type Props = {
    title?: string,
    content: string | React.Node,
    popoverContent?: string | React.Node,
};

export function SummaryContent(props: Props) {
    const [isViewingInfo, setIsViewingInfo] = React.useState(false);
    const buttonRef = React.useRef(null);

    const defaultPopoverContent = (
        <>
            <strong>Timeline summaries</strong> use artificial intelligence to analyze your
            interactions, highlight important moments, and provide key insights. This AI-powered
            tool enables you to quickly understand your progress, identify patterns, and make
            informed decisions.
        </>
    );

    return (
        <>
            <div styleName='timeline-summary'>
                <Card hasBorder={true} hasShadow={true} leftLineColor={colors.aiBlue}>
                    <div className='pad-16'>
                        <div className='flex justify-sb align-center mb-8'>
                            <StackLegacy spacing={4} isHorizontal={true} alignCenter={true}>
                                <AiSparkleNewIcon size={17} alignCenter={true} />
                                <div styleName='header-title'>
                                    {props.title || 'Timeline summary'}
                                </div>
                            </StackLegacy>
                            <ButtonMover size='normal' direction='right'>
                                <Button
                                    getButtonRef={buttonRef}
                                    variant='text-primary'
                                    onClick={() => {
                                        setIsViewingInfo(true);
                                    }}
                                >
                                    What is this?
                                </Button>
                            </ButtonMover>
                        </div>
                        {props.content}
                    </div>
                </Card>
            </div>
            {isViewingInfo ? (
                <Popover
                    anchor={buttonRef.current}
                    bodyColor='dark'
                    location='top-left'
                    onBlur={() => {
                        setIsViewingInfo(false);
                    }}
                >
                    <div styleName='popover-content'>
                        {props.popoverContent || defaultPopoverContent}
                    </div>
                </Popover>
            ) : null}
        </>
    );
}
